<template>
	<div class="bigs" style="background: #fff;">
		<navigation></navigation>
		<div class="title-head">请使用手机号验证码登录</div>
		<div class="pwd">
			<img class="iphones" src="../../../assets/iphone.png" />
			<input type="text" maxlength="11" style="width: 2.5rem;" v-model="form.loginName" placeholder="请输入手机号" />
			<div v-show="show" @click="getCode" id="yzm">获取验证码</div>
			<div v-show="!show"  id="yzm">{{count}} </div>
		</div>
		<div class="pwd">
			<img class="pwds" src="../../../assets/pwd.png" />
			<input  type="password" v-model="form.smsCode" placeholder="请输入验证码" />
		</div>
		<div class="mains">
			关于支付：
			<br />
			1、苹果手机用户可通该页面通道支付
			<br />
			2、安卓手机用户可直接通过APP支付
			<br />
			3、未注册，请下载交道APP
			<br />
			4、登录后，请选择学习系统进行缴费
			<br />
		</div>
		<div id="btn" @click="btn">确 &nbsp; 定</div>
		<div id="btns" @click="loginTab" >账号密码登录</div>
	</div>
</template>

<script>
import { Toast, Sidebar, List, SidebarItem, PullRefresh, Overlay, Tab, Tabs, Cell, Loading, Card, Dialog,Notify  } from 'vant';
import navigation from '../../components/nav';
import request from '@/utils/request';
export default {
	components: {
		navigation,
		[Toast.name]: Toast,
		[Sidebar.name]: Sidebar,
		[List.name]: List,
		[SidebarItem.name]: SidebarItem,
		[PullRefresh.name]: PullRefresh,
		[Overlay.name]: Overlay,
		[Tab.name]: Tab,
		[Tabs.name]: Tabs,
		[Cell.name]: Cell,
		[Loading.name]: Loading,
		[Dialog.name]: Dialog,
		[Notify.name]: Notify
	},
	data() {
		return {
			form: {
				loginName: '',
				smsCode: ''
			},
			show:true, //手机验证码登录 切换
			count:0
		};
	},
	created() {

	},
	mounted() {
		let _this = this;
	},

	methods: {
		btn() {
			let _this = this;
			if(!(/^1[3456789]\d{9}$/.test(_this.form.loginName))){
			   Dialog.alert({
			   	message: '请输入正确手机号'
			   }).then(() => {
			   	// on close
			   });
			   return;
			}
			if(_this.form.smsCode == ''){
				Dialog.alert({
					message: '验证码不能为空'
				}).then(() => {
					// on close
				});
				return;
			}

			let urls = Global.env + Global.apiCore.yzmLogin;
			return new Promise((resolve, reject) => {
				request({
					url: urls,
					method: 'post', //查询一般为get
					data: _this.form //get
				})
					.then(response => {
						if (response.resultCode == '1000') {
							localStorage.setItem('token',response.data.token);
							let url = Global.env + Global.apiCore.Authentication;
							return new Promise((resolve, reject) => {
								request({
									url: url,
									method: 'get', //查询一般为get
								})
									.then(response => {
										// if (response.data.missingType == '0') {
											Notify({ type: 'success', message: '登录成功' });
											setTimeout(function(){
												// window.location.href="https://wx.zpkjedu.com/wechat/authorize?returnUrl=http://m-test.jiaodao11.com/filterSystem"
												window.location.href="https://wx.zpkjedu.com/wechat/authorize?returnUrl=https://m.jiaodao11.com/filterSystem"
											},1000)
										// } else {
										// 	Dialog.alert({
										// 		message: "请去App认证、核对",
										// 	}).then(() => {
										// 	});
										// }
									})
									.catch(error => {
										Dialog.alert({
											message: error.errmsg
										}).then(() => {
											// on close
										});
										return reject(error);
									});
							});
							// this.$router.push({
							// 	name: 'FilterSystem',
							// 	query: {
							// 	}
							// })
						} else if(response.resultCode == '1001'){
							Dialog.alert({
								message: '请输入正确的账号'
							}).then(() => {
								// on close
							});
						}else if(response.resultCode == '1002'){
							Dialog.alert({
								message: '请输入正确的账号'
							}).then(() => {
								// on close
							});
						}else if(response.resultCode == '3001'){
							Dialog.alert({
								message: '验证码错误'
							}).then(() => {
								// on close
							});
						}else if(response.resultCode == '2001'){
							Dialog.alert({
								message: '用户不存在'
							}).then(() => {
								// on close
							});
						}
					})
					.catch(error => {
						Dialog.alert({
							message: error.errmsg
						}).then(() => {
							// on close
						});
						return reject(error);
					});
			});

			// localStorage.setItem('token', JSON.stringify(_this.form));
			// localStorage.getItem(name);
			// localStorage.removeItem(name);
		},
		loginTab() {
			this.$router.push({
				name: 'Login',
				query: {
				}
			});
		},
		getCode(){ //获取验证码
		 const TIME_COUNT = 60;
		if(!(/^1[3456789]\d{9}$/.test(this.form.loginName))){
		   Dialog.alert({
		   	message: '请输入正确手机号'
		   }).then(() => {
		   	// on close
		   });
		   return;
		}
		 if(!this.timer) {
		   this.count = TIME_COUNT;
		   this.show = false;
		   this.timer = setInterval(() => {
		   if (this.count > 0 && this.count <= TIME_COUNT) {
		     this.count--;
		    } else {
		     this.show = true;
		     clearInterval(this.timer);
		     this.timer = null;
		    }
		   }, 1000)

		   let yzm = this.$md5(this.form.loginName + 'zpkj');
		    this.smsCode(this.form.loginName,yzm);//手机号登录获取验证码
		  }
		},
		smsCode(phone,yzm){//获取短信验证码
		  let _this = this;
		  let url = Global.env + Global.apiCore.getSmsCode;
		  return new Promise((resolve, reject) => {
		    request({
		      url: url,
		      method: 'post',
		      data:{
				  loginName:phone,
				  loginWap:yzm,
				  },
		    }).then(response => {
		      if (response.resultCode === '1000') {

		        return resolve()
		      } else if(response.resultCode == '1999'){
							Dialog.alert({
								message: '签名验证错误'
							}).then(() => {
								// on close
							});
						}else if(response.resultCode == '1001'){
							Dialog.alert({
								message: '请输入正确的账号'
							}).then(() => {
								// on close
							});
						}else if(response.resultCode == '1002'){
							Dialog.alert({
								message: '请输入正确的账号'
							}).then(() => {
								// on close
							});
						}else if(response.resultCode == '2001'){
							Dialog.alert({
								message: '用户不存在'
							}).then(() => {
								// on close
							});
						}else if(response.resultCode == '160038'){
							Dialog.alert({
								message: '短信验证码发送过频繁,请一个小时以后再试！'
							}).then(() => {
								// on close
							});
						}else if(response.resultCode == '300001'){
							Dialog.alert({
								message: '用户账号已经被关闭，无法登录！'
							}).then(() => {
								// on close
							});
						}
		    }).catch(error => {
		        _this.$root.tips("网络有误，联系管理员","error")
		        return reject(error);
		    })
		  })
		}
	}
};
</script>

<style>
.title-head {
	font-size: 0.36rem;
	font-weight: 400;
	color: rgba(51, 51, 51, 1);
	margin: 0 auto;
	margin-top: 0.62rem;
	margin-bottom: 0.8rem;
	text-align: center;
}
.pwd {
	width: 75%;
	height: 1.06rem;
	overflow: hidden;
	border-bottom: 1px solid rgba(242, 242, 242, 1);
	margin: 0 auto;
	position: relative;
}
.pwds {
	width: 0.28rem;
	height: 0.34rem;
	position: absolute;
	left: 0.2rem;
	top: 0.34rem;
}
.iphones {
	width: 0.3rem;
	height: 0.36rem;
	position: absolute;
	left: 0.2rem;
	top: 0.34rem;
}
.pwd input {
	width: 4rem;
	line-height: 1.04rem;
	border: none;
	font-size: 0.3rem;
	font-weight: 400;
	color: rgba(195, 195, 195, 1);
	position: absolute;
	left: 0.8rem;
	top: 0;
}
.mains {
	width: 75%;
	margin: 0 auto;
	margin-top: 0.7rem;
	line-height: 0.5rem;
	font-size: 0.3rem;
	font-weight: 400;
	color: rgba(246, 60, 69, 1);
}
#btn {
	width: 75%;
	height: 0.82rem;
	line-height: 0.82rem;
	background: #f63c45;
	border-radius: 4px;
	margin: 0 auto;
	margin-top: 2rem;
	text-align: center;
	font-weight: 400;
	color: rgba(255, 255, 255, 1);
	font-size: 0.34rem;
}
#btns{
	width: 75%;
	height: 0.82rem;
	line-height: 0.82rem;
	border-radius: 4px;
	margin: 0 auto;
	margin-top: 0.2rem;
	text-align: center;
	font-weight: 400;
	color: #007bff;
	font-size: 0.34rem;
	margin-bottom: 1rem;
}
#yzm{
	display: block;
	font-size: 0.3rem;
	float: right;
	width: 1.98rem;
	height: 0.7rem;
	line-height: 0.7rem;
	text-align: center;
	border-radius:0.3rem;
	margin-top: 0.15rem;
	border:1px solid #333;
	color: #333;
}
/* .van-toast__text{
	font-size: 0.36rem !important;
} */

.van-button--large {
	line-height: 0 !important;
	font-size: 0.32rem !important;
}
</style>
